import React from 'react';
import {BREAKPOINT_ID_MAIN} from '@packages/systems/style/breakpoint-ids';
import {
  withSystem,
  Plugins,
  Atom,
  AtomRenderProps,
} from '@packages/systems/wfdl';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {
  EvaluatedNodeData,
  getChildren,
  getInPojo,
  getTagOrElse,
} from '@packages/utilities/data-utils';
import {List} from 'immutable';

// @ts-expect-error - TS7006 - Parameter 'index' implicitly has an 'any' type.
const transformWidths = (width: any, index) => {
  if (width && width.split('|').length > 1) {
    return width.split('|')[index];
  } else {
    return width;
  }
};

const trimStack = (width: any) => (/stack$/.test(width) ? 'stack' : width);

const columnClass = (width: any, key: any) => (columnClasses: List<string>) => {
  if (/main$/.test(key) || /medium/.test(width)) {
    return columnClasses.push(`w-col-${trimStack(width)}`);
  } else if (!width) {
    return columnClasses;
  } else {
    return columnClasses.push(`w-col-${key}-${width}`);
  }
};

const Column = Atom.createRender(
  ({
    data,
    attributes,
    classes,
    context,
    generateAttributes,
    renderChild,
  }: AtomRenderProps) => {
    const Tag = getTagOrElse(getInPojo(data, ['tag']), 'div');
    const widths = context.get('widths');
    const index = context.get('columnIndex');
    let columnClasses = classes.push('w-col');

    widths &&
      // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
      widths.forEach((value, key) => {
        const width =
          value === 'custom'
            ? transformWidths(widths.get(BREAKPOINT_ID_MAIN), index)
            : transformWidths(value, index);
        columnClasses = columnClasses.update(columnClass(width, key));
      });

    return (
      <Tag {...generateAttributes(attributes, columnClasses)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  constraints: {
    pinToParent: true,
    parent: [
      {
        is: 'Row',
        rule: 'ExactlyOne',
      },
    ],
  },
  displayName: {
    type: 'Enumerated',
    value: 'Column',
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Layout'), iconName('Column')),
  },
  lockedStyles: {
    float: {
      when: true,
      message: 'Webflow handles floats for columns automatically.',
    },
    marginLeft: {
      when: true,
      message:
        'Use padding instead of margin to ensure your column-based design remains responsive.',
    },
    marginRight: {
      when: true,
      message:
        'Use padding instead of margin to ensure your column-based design remains responsive.',
    },
    width: {
      when: true,
      message: 'Adjust column width in the Settings panel.',
    },
    minWidth: {
      when: true,
      message: 'Adjust column width in the Settings panel.',
    },
    maxWidth: {
      when: true,
      message: 'Adjust column width in the Settings panel.',
    },
  },
  render: Column,
  showEmpty: true,
  fields: {
    tag: withSystem(
      {
        label: 'Tag',
        private: true,
        defaultValue: 'div',
        isLocalizable: true,
      },
      TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
    ),
    children: TListOfElement,
  },
});

export default config;
